var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:visa",
    clipPath: "url(#clip0_97_2433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.5477 6.36811C31.5129 9.14305 33.9932 10.6915 35.8616 11.6122C37.7812 12.5568 38.4259 13.1626 38.4183 14.0074C38.404 15.3002 36.8871 15.8708 35.4677 15.8929C32.9912 15.9317 31.5513 15.2168 30.4066 14.6761L29.5145 18.8975C30.663 19.4327 32.7896 19.8994 34.9949 19.9199C40.1716 19.9199 43.5583 17.3358 43.5766 13.3293C43.5969 8.2445 36.6217 7.96305 36.6693 5.69028C36.6858 5.00113 37.3361 4.26571 38.761 4.07872C39.4663 3.98426 41.4133 3.91197 43.6207 4.93992L44.4871 0.855585C43.3 0.418476 41.7743 -7.82013e-05 39.8747 -7.82013e-05C35.0023 -7.82013e-05 31.5754 2.6192 31.5477 6.36811ZM52.8122 0.351728C51.8669 0.351728 51.0703 0.909319 50.7148 1.76498L43.3202 19.6199H48.4931L49.5225 16.7431H55.8436L56.4407 19.6199H61L57.0214 0.351728H52.8122ZM53.5358 5.55679L55.0287 12.7922H50.9402L53.5358 5.55679ZM25.2759 0.351969L21.1985 19.6197H26.1278L30.2033 0.351488L25.2759 0.351969ZM17.9838 0.351969L12.8531 13.4664L10.7777 2.31534C10.5342 1.07052 9.57247 0.351728 8.5045 0.351728H0.117473L0 0.911247C1.72182 1.28908 3.67811 1.89848 4.86332 2.55052C5.58865 2.94884 5.79548 3.29703 6.03376 4.24354L9.96468 19.6199H15.1737L23.16 0.351728L17.9838 0.351969Z",
    fill: "url(#paint0_linear_97_2433)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_2433",
    x1: 2804.41,
    y1: 59.8794,
    x2: 2862.72,
    y2: -1985.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_2433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVisa);
export default __webpack_public_path__ + "static/media/logos_visa.03d9da78672ec08e7db6c6f6904c5fde.svg";
export { ForwardRef as ReactComponent };